import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    circularLoading: {
      width: theme.spacing(2),
      height: theme.spacing(2),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      webkitAnimation: 'spin 2s linear infinite',
      mozAnimation: 'spin 2s linear infinite',
      animation: 'spin 2s linear infinite',
    },
  })
);
